import React, { useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom'; // Corrected import for useParams
import { updateData, postData, fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { Tooltip } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const BankEdit = () => {
    const { id: recordId } = useParams(); // Use useParams to get the record ID from the URL
    const history = useHistory();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [formData, setFormData] = useState({
        BankName: '',
        IFSC: '',
        AccountNo: '',
        Branch: '',
        IsPayable: true,
        OpeningBalance: 0,
        CompanyId: companyId,
    });

    useEffect(() => {
        fetchData('BankApi', `/bank/${recordId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    setFormData(response.response_data);
                    setFormData(prevData => ({
                        ...prevData,
                        UpdatedBy: userId,
                    }));
                }
            })
            .catch((error) => {
                console.error('Error fetching Bank Details:', error);
            });
    }, []);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : type === 'radio' ? value === 'true' : value,
        }));
    };

    const submitData = (event) => {
        event.preventDefault();
        setIsLoading(true);

        const CreateData = {
            ...formData,
            UpdatedBy: userId,
            CompanyId: companyId,
        };

        if (!formData.BankName) { // Check if the category is selected
            setErrorMessage("Name is required!");
            setIsLoading(false);
            return;
        }

        if (!formData.AccountNo) { // Check if the category is selected
            setErrorMessage("Account Number is required!");
            setIsLoading(false);
            return;
        }

        if (!formData.IFSC) { // Check if the category is selected
            setErrorMessage("IFSC Code is required!");
            setIsLoading(false);
            return;
        }

        updateData('BankApi', `${recordId}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/BankIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };


    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <form onSubmit={submitData}>
                <div className="w-full mb-2 flex">
                    <h5 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Bank - Edit</h5>
                    <Tooltip title="Exit">
                        <Link to="/bankindex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                            <Button style={{ color: 'brown', fontWeight: 'bolder' }}>
                                Back To List <ArrowForwardIosIcon />
                            </Button>
                        </Link>
                    </Tooltip>
                    <Tooltip title="SAVE">

                        <Button onClick={submitData} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                        </Button>

                    </Tooltip>
                </div>
                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                <div className="w-full mb-4 flex">
                    <div className="w-full mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                            Name
                            <span className="text-red-500">*</span>
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name="BankName"
                            value={formData.BankName}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter name"
                            required
                            maxLength={50}
                        />
                    </div>

                </div>

                <div className="w-full mb-4 flex">
                    <div className="w-2/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="contactNumber1">
                            IFSC Code
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name="IFSC"
                            value={formData.IFSC}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter IFSC Code"
                            required
                            maxLength={30}
                        />
                    </div>

                    <div className="w-2/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="email">
                            Account Number
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name="AccountNo"
                            value={formData.AccountNo}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter Account Number"
                            maxLength={40}
                        />
                    </div>

                    <div className="w-2/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="email">
                            Branch Name
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name="Branch"
                            value={formData.Branch}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter Branch"
                            maxLength={50}
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="openingBalance">
                            Opening Balance
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name="OpeningBalance"
                            value={formData.OpeningBalance}
                            onChange={handleChange}
                            type="number"
                            placeholder="Enter Opening Balance"
                        />
                    </div>
                    <div className="w-1/4 mr-2">
                        <div className="inline-flex items-center">
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4 text-green-500 border-4 border-gray-400 rounded-md checked:bg-green-500 checked:border-transparent"
                                name="IsPayable"
                                checked={formData.IsPayable}
                                onChange={handleChange}
                                style={{ marginTop: '35px', marginLeft: '20px' }}
                            />
                            <span className="ml-2" style={{ marginTop: '35px' }}>Is Payable?</span>
                        </div>
                    </div>
                </div>

                <div className="w-full mb-4 flex">
                    <div className="w-2/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                            Payment QR UPI Id
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='PaymentQRcodeUPIID'
                            value={formData.PaymentQRcodeUPIID}
                            onChange={handleChange} type="text"
                            placeholder="Enter UPI Id" />
                    </div>

                    <div className="w-2/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                            Payment QR UPI Name
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='UPIName'
                            value={formData.UPIName}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter UPI Name" />
                    </div>

                    <div className="w-1/4 mr-2">
                        <div className="inline-flex items-center">
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4 text-green-500 border-4 border-gray-400 rounded-md checked:bg-green-500 checked:border-transparent"
                                name="IsPrimary"
                                checked={formData.IsPrimary}
                                onChange={handleChange}
                                style={{ marginTop: '35px', marginLeft: '20px' }}
                            />
                            <span className="ml-2" style={{ marginTop: '35px' }}>Is Primary?</span>
                        </div>
                    </div>
                </div>

            </form >
        </div >
    );
};

export default BankEdit;
